<template>
  <div class="wrapper">
    <div class="animated fadeIn dashboard-container">
      <!-- B2B Dashboard (do not change) -->
      <!-- <b-card class="mb-3">
        <div>
          <b>B2B Dashboard</b>
          <span class="d-block mb-2 mt-2">B2B Forward</span>
          <b-row v-if="Object.keys(b2bDashboardCount).length">
            <b-col cols="2" v-for="item,index in Object.entries(b2bDashboardCount)" :key="item[0]">
              <a :href="item[0]" class="text-decoration-none" @click.prevent="goToB2B">
                <b-card :class="b2bDashboardColorArr[index % b2bDashboardColorArr.length]">
                  <b-card-body class="d-flex flex-column align-items-center text-white p-2">
                    <span class="display-3">{{ item[1] }}</span>
                    <span>{{ item[0] }}</span>
                  </b-card-body>
                </b-card>
              </a>
            </b-col>
          </b-row>
          <span class="d-block mb-2 mt-2">B2B Reverse</span>
          <b-row v-if="Object.keys(b2bReverseDashboardCount).length">
            <b-col cols="2" v-for="item,index in Object.entries(b2bReverseDashboardCount)" :key="item[0]">
              <a :href="item[0]" class="text-decoration-none" @click.prevent="goToB2B">
                <b-card :class="b2bRevDashboardColorArr[index % b2bRevDashboardColorArr.length]">
                  <b-card-body class="d-flex flex-column align-items-center text-white p-2">
                    <span class="display-3">{{ item[1] }}</span>
                    <span>{{ item[0] }}</span>
                  </b-card-body>
                </b-card>
              </a>
            </b-col>
          </b-row>
          <b-row v-if="showB2BDashboardLoader || failMsgForB2BDashboard">
            <b-col>
              <b-card>
                <b-card-body class="d-flex flex-column align-items-center text-dark p-2">
                  <span class="spinner-border" v-if="showB2BDashboardLoader"></span>
                  <span v-if="failMsgForB2BDashboard">{{failMsgForB2BDashboard}}</span>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-card> -->

      <b-card class="mb-3" ref="b2bSection">
        <h4 class="section-title mb-3">
            <i class="fas fa-truck"></i>
            B2B Forward
        </h4>
        <b-row>
            <b-col md="3" v-for="bucket in b2bForwardBuckets" :key="bucket.label">
                <a :href="bucket.label" @click.prevent="goToB2B" class="text-decoration-none">
                <b-card
                    class="stat-card mb-3 d-flex flex-column align-items-center justify-content-center"
                    :style="{ borderLeft: `4px solid ${bucket.color}`, minHeight: '140px' }"
                >
                    <div class="stat-icon mb-2" :style="{ color: bucket.color }">
                    <i :class="bucket.icon"></i>
                    </div>
                    <div class="stat-value h4 mb-0">{{ bucket.value }}</div>
                    <div class="stat-label text-muted small mb-1">{{ bucket.label }}</div>
                </b-card>
                </a>
            </b-col>
        </b-row>

        <h4 class="section-title mb-3 mt-4">
            <i class="fas fa-undo-alt"></i>
            B2B Reverse
        </h4>
        <b-row>
            <b-col md="3" v-for="bucket in b2bReverseBuckets" :key="bucket.label">
                <a :href="bucket.label" @click.prevent="goToB2B" class="text-decoration-none">
                <b-card
                    class="stat-card mb-3 d-flex flex-column align-items-center justify-content-center"
                    :style="{ borderLeft: `4px solid ${bucket.color}`, minHeight: '140px' }"
                >
                    <div class="stat-icon mb-2" :style="{ color: bucket.color }">
                    <i :class="bucket.icon"></i>
                    </div>
                    <div class="stat-value h4 mb-0">{{ bucket.value }}</div>
                    <div class="stat-label text-muted small mb-1">{{ bucket.label }}</div>
                </b-card>
                </a>
            </b-col>
        </b-row>
      </b-card>

      <!-- Dispatch Pending Report (Hub Wise) (do not change) -->
      <b-card ref="dispatchSection">
        <h4 class="section-title mb-3">
          <i class="fas fa-clipboard-list"></i>
          Dispatch Pending Report (Hub Wise)
        </h4>
        <b-row>
          <b-col md="3" v-for="hub in hubPending" :key="hub.name">
            <b-card :class="['hub-pending-card', hub.color, 'mb-3']">
              <div class="d-flex align-items-center mb-2">
                <i :class="hub.icon" class="mr-2"></i>
                <span class="fw-bold">{{ hub.name }}</span>
              </div>
              <div class="pending-count h4 mb-0">{{ hub.pending }}</div>
              <div class="text-muted medium mb-1">Pending Dispatch Count</div>
              <hr class="my-2" />
              <div class="d-flex justify-content-between text-center">
                <div class="flex-fill">
                  <span class="fw-bold">{{ hub.lastDispatch }}</span>
                  <div class="text-muted medium">Last Dispatch</div>
                </div>
                <div class="flex-fill">
                  <span class="fw-bold">{{ hub.todaysDispatch }}</span>
                  <div class="text-muted medium">Today's Dispatch</div>
                </div>
              </div>
              <b-button variant="primary" block size="sm" class="mt-2" @click="goToHubPendingReport(hub)">View Details</b-button>
            </b-card>
          </b-col>
        </b-row>

        <!-- Vendor Pickup Details (document design, max 4 per row, color & icon as per doc, no progress bar) -->
         <div ref="vendorSection">    
        <h4 class="section-title mt-4 mb-3">
          <i class="fas fa-truck-loading"></i>
          Vendor Pickup Details
        </h4>
        <b-row class="mb-3">
          <b-col md="3">
            <label for="vendor" class="form-label">Vendor</label>
            <b-form-select id="vendor" v-model="selectedVendor" :options="vendorOptions"></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3" v-for="stat in vendorStatsDoc" :key="stat.label">
            <a href="#" @click.prevent="goToKsaReport(stat, 'vendor')" class="text-decoration-none">
              <b-card
                class="stat-card mb-3 d-flex flex-column align-items-center justify-content-center"
                :style="{
                  borderLeft: `4px solid ${stat.color}`,
                  minHeight: '140px'
                }"
              >
                <div class="stat-icon mb-2" :style="{ color: stat.color }">
                  <i :class="stat.icon"></i>
                </div>
                <div class="stat-value h4 mb-0">{{ stat.value }}</div>
                <div class="stat-label text-muted small mb-1">{{ stat.label }}</div>
              </b-card>
            </a>
          </b-col>
        </b-row>
        </div>

        <!-- LPC Dispatch Details (document design, color & icon as per doc, no progress bar) -->
        <div ref="lpcSection">
        <h4 class="section-title mt-4 mb-3">
          <i class="fas fa-shipping-fast"></i>
          LPC Dispatch Details
        </h4>
        <b-row class="mb-3">
          <b-col md="3">
            <label for="lpcType" class="form-label">Shipment Type</label>
            <b-form-select id="lpcType" v-model="selectedLpcType" :options="lpcTypeOptions"></b-form-select>
          </b-col>
          <b-col md="3" v-if="selectedLpcType === 'vendor'">
            <label for="lpcVendor" class="form-label">Vendor</label>
            <b-form-select id="lpcVendor" v-model="selectedLpcVendor" :options="lpcVendorOptions"></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3" v-for="stat in lpcStatsDoc" :key="stat.label">
            <a href="#" @click.prevent="goToKsaReport(stat, 'lpc')" class="text-decoration-none">
              <b-card
                class="stat-card mb-3 d-flex flex-column align-items-center justify-content-center"
                :style="{
                  borderLeft: `4px solid ${stat.color}`,
                  minHeight: '140px'
                }"
              >
                <div class="stat-icon mb-2" :style="{ color: stat.color }">
                  <i :class="stat.icon"></i>
                </div>
                <div class="stat-value h4 mb-0">{{ stat.value }}</div>
                <div class="stat-label text-muted small mb-1">{{ stat.label }}</div>
              </b-card>
            </a>
          </b-col>
        </b-row>
        </div>

        <!-- RTO Details (document design, color & icon as per doc, no progress bar) -->
        <div ref="rtoSection">
        <h4 class="section-title mt-4 mb-3">
          <i class="fas fa-undo-alt"></i>
          RTO Details
        </h4>
        <b-row class="mb-3">
          <b-col md="3">
            <label for="rtoVendor" class="form-label">Vendor</label>
            <b-form-select id="rtoVendor" v-model="selectedRtoVendor" :options="rtoVendorOptions"></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3" v-for="stat in rtoStatsDoc" :key="stat.label">
            <a href="#" @click.prevent="goToKsaReport(stat, 'rto')" class="text-decoration-none">
              <b-card
                class="stat-card mb-3 d-flex flex-column align-items-center justify-content-center"
                :style="{
                  borderLeft: `4px solid ${stat.color}`,
                  minHeight: '140px'
                }"
              >
                <div class="stat-icon mb-2" :style="{ color: stat.color }">
                  <i :class="stat.icon"></i>
                </div>
                <div class="stat-value h4 mb-0">{{ stat.value }}</div>
                <div class="stat-label text-muted small mb-1">{{ stat.label }}</div>
              </b-card>
            </a>
          </b-col>
        </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
export default {
  name: "dashboard_ksa",
  data() {
    return {
      apiLoaded: {
        b2b: false,
        vendor: false,
        lpc: false,
        rto: false
      },
      b2bForwardBuckets: [
        { label: "BookingPending", value: 0, icon: "fas fa-calendar-plus", color: "#3498db" },
        { label: "OFD", value: 0, icon: "fas fa-truck", color: "#2ecc71" },
        { label: "Delivered", value: 0, icon: "fas fa-check-circle", color: "#e74c3c" },
        { label: "NDR", value: 0, icon: "fas fa-exclamation-circle", color: "#f39c12" },
        { label: "RTO", value: 0, icon: "fas fa-undo-alt", color: "#e67e22" }
      ],
      b2bReverseBuckets: [
        { label: "PickupPending", value: 0, icon: "fas fa-clock", color: "#3498db" },
        { label: "PickupDone", value: 0, icon: "fas fa-check", color: "#2ecc71" },
        { label: "DeliveredToWH", value: 0, icon: "fas fa-warehouse", color: "#e74c3c" },
        { label: "NPR", value: 0, icon: "fas fa-exclamation-circle", color: "#f39c12" }
      ],

      b2bDashboardColorArr: ['bg-aqua','bg-green','bg-yellow','bg-pink','bg-purpal','bg-cyan','bg-red','bg-def'],
      b2bRevDashboardColorArr: ['bg-dark','bg-cyan','bg-red','bg-def'],
      showB2BDashboardLoader: false,
      failMsgForB2BDashboard: null,
      hubPending: [
        {
          name: "Dammam Hub",
          pending: 0,
          lastDispatch: "-",
          todaysDispatch: 0,
          color: "dammam",
          icon: "fas fa-warehouse",
          pickuplocationmasterid: 6331
        },
        {
          name: "Riyadh Hub",
          pending: 0,
          lastDispatch: "-",
          todaysDispatch: 0,
          color: "riyad",
          icon: "fas fa-warehouse",
          pickuplocationmasterid: 592
        },
        {
          name: "Jeddah Hub",
          pending: 0,
          lastDispatch: "-",
          todaysDispatch: 0,
          color: "jed",
          icon: "fas fa-warehouse",
          pickuplocationmasterid: 590
        },
        {
          name: "Makkah Hub",
          pending: 0,
          lastDispatch: "-",
          todaysDispatch: 0,
          color: "mak",
          icon: "fas fa-warehouse",
          pickuplocationmasterid: 435
        }
      ],
      vendorOptions: [
        { value: null, text: "All Vendors" },
        { value: "Vendor A", text: "Vendor A" },
        { value: "Vendor B", text: "Vendor B" },
        { value: "Vendor C", text: "Vendor C" },
      ],
      selectedVendor: null,
      // Vendor Pickup Details buckets (color & icon as per doc, no progress bar)
      vendorStatsDoc: [
        { label: "Ready to Allocate the Rider", value: 0, icon: "fas fa-box-open", color: "#3498db" },
        { label: "Rider Pickup Pending", value: 0, icon: "fas fa-tasks", color: "#2ecc71" },
        { label: "Rider Pickup Done", value: 0, icon: "fas fa-motorcycle", color: "#e74c3c" },
        { label: "Received in Hub", value: 0, icon: "fas fa-warehouse", color: "#f39c12" },
      ],
      // LPC Dispatch Details buckets (color & icon as per doc, no progress bar)
      selectedLpcType: null,
      selectedLpcVendor: null,
      lpcStatsDoc: [
        { label: "Shipment Created", value: 0, icon: "fas fa-box", color: "#3498db" },
        { label: "Shipment Received", value: 0, icon: "fas fa-check-circle", color: "#2ecc71" },
        { label: "HUB Inscan", value: 0, icon: "fas fa-warehouse", color: "#e74c3c" },
        { label: "Pallet Created", value: 0, icon: "fas fa-pallet", color: "#f39c12" },
        { label: "Pallet Closed", value: 0, icon: "fas fa-times-circle", color: "#e67e22" },
        { label: "Dispatch from LPC", value: 0, icon: "fas fa-truck", color: "#2980b9" },
      ],
      lpcTypeOptions: [
        { value: null, text: "All" },
        { value: "wh", text: "Warehouse" },
        { value: "vendor", text: "Vendor" },
      ],
      lpcVendorOptions: [
        { value: null, text: "All Vendors" },
        { value: "Vendor X", text: "Vendor X" },
        { value: "Vendor Y", text: "Vendor Y" },
        { value: "Vendor Z", text: "Vendor Z" },
      ],
      // RTO Details buckets (color & icon as per doc, no progress bar)
      rtoStatsDoc: [
        // { label: "RTO Dispatch", value: 0, icon: "fas fa-truck-loading", color: "#3498db" },
        // { label: "RTO Received", value: 0, icon: "fas fa-check-circle", color: "#2ecc71" },
        { label: "RTO Received in LPC", value: 0, icon: "fas fa-truck-loading", color: "#3498db" },
        { label: "Rintransit LMD TO LPC", value: 0, icon: "fas fa-check-circle", color: "#2ecc71" },
        { label: "RBookingDone", value: 0, icon: "fas fa-tasks", color: "#f39c12" },
        { label: "RTO Handover to WH", value: 0, icon: "fas fa-warehouse", color: "#f39c12" },
      ],
      rtoVendorOptions: [
        { value: null, text: "All Vendors" },
        { value: "Vendor A", text: "Vendor A" },
        { value: "Vendor B", text: "Vendor B" },
        { value: "Vendor C", text: "Vendor C" },
      ],
      selectedRtoVendor: null,
      // For legacy sections
      lpcStats: [],
      rtoStats: [],

      scrolled: false,

      loader: {
      b2b: false,
      vendor: false,
      lpc: false,
      rto: false,
      b2b_cms_url: null,
    },
    };
  },
  created: function() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.userCountry = userInfo.country;
    console.log("Country", this.userCountry);
    window.addEventListener("scroll", this.scroll);
    this.getVendorList();
    this.getHubWisePendingDetails();
    // this.getVendorPickupDetails();
    // this.getLpcDispatchDetails();
    // this.getRTODetails();
    this.b2b_cms_url=`https://www.firstcrylogistics.com/b2b_cms/shipmentReport?status=`
  },
  watch: {
    selectedLpcType: 'getLpcDispatchDetails',
    selectedLpcVendor: 'getLpcDispatchDetails',
    selectedVendor: 'getVendorPickupDetails',
    selectedRtoVendor: 'getRTODetails',
  },
  destroyed() {
    // alert("innn");
    window.removeEventListener("scroll", this.scroll);
  },
  mounted() {
    // this.lazyloadingcall();
    // this.showB2BDashboardLoader = true
    // setTimeout(()=>{
    //   if(this.userCountry=="KSA"){
    //       this.getb2bDashboardCountForAdmin();
    //   }
    // },500)

    // Always load dispatch pending report
    this.getHubWisePendingDetails();

    // Lazy load other sections
    this.observeSection('b2bSection', () => {
      if (!this.apiLoaded.b2b) {
        this.getb2bDashboardCountForAdmin();
        this.apiLoaded.b2b = true;
      }
    });
    this.observeSection('vendorSection', () => {
      if (!this.apiLoaded.vendor) {
        this.getVendorPickupDetails();
        this.apiLoaded.vendor = true;
      }
    });
    this.observeSection('lpcSection', () => {
      if (!this.apiLoaded.lpc) {
        this.getLpcDispatchDetails();
        this.apiLoaded.lpc = true;
      }
    });
    this.observeSection('rtoSection', () => {
      if (!this.apiLoaded.rto) {
        this.getRTODetails();
        this.apiLoaded.rto = true;
      }
    });
  },
  methods: {
    observeSection(refName, callback) {
      const el = this.$refs[refName];
      if (!el) return;
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          callback();
          observer.disconnect();
        }
      }, { threshold: 0.1 });
      observer.observe(el);
    },
    // scroll() {
    //   if (window.scrollY > 0 && !this.scrolled) {
    //     this.scrolled = true;
    //     // Call lazy APIs after scroll
    //     this.getb2bDashboardCountForAdmin();
    //     this.getVendorPickupDetails();
    //     this.getLpcDispatchDetails();
    //     this.getRTODetails();
    //   }
    // },
    
    goToKsaReport(bucket, section) {
      let params = {
        status: bucket.label == 'RTO Received in LPC' ? 'RTO Dispatch' : bucket.label == 'Rintransit LMD TO LPC' ? 'RTO Received' : bucket.label
      };
      if (section === 'vendor') {
        params.vendor_id = this.selectedVendor || null;
      }
      if (section === 'lpc') {
        params.shipmenttype = this.selectedLpcType || null;
        if (this.selectedLpcType === 'vendor') {
          params.vendor_id = this.selectedLpcVendor || null;
        }
      }
      if (section === 'rto') {
        params.vendor_id = this.selectedRtoVendor || null;
      }
      // Use params instead of query
      this.$router.push({ name: 'shipmentreport_ksa', params });
    },

    goToHubPendingReport(hub) {
      this.$router.push({
        name: 'shipmentreport_ksa',
        params: {
          status: 'Dispatch Pending',
          hub_id: hub.pickuplocationmasterid 
        }
      });
    },

    getVendorList() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj = {  };
        
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVendorList_ksa`, obj)
        .then(result => {
            if (result.data.returnmsg === "Successful") {
            const list = result.data.returnvalue || [];
            const options = [{ value: null, text: "All Vendors" }]
                .concat(list.map(v => ({
                value: v.pickuplocationmasterid,
                text: v.pickuplocationname
                })));
            this.vendorOptions = options;
            this.lpcVendorOptions = options;
            this.rtoVendorOptions = options;
            }
        });
    },
    goToB2B(event) {
        const hrefValue = event.currentTarget.getAttribute('href');
        if(window.location.origin=='http://localhost:8080'){
        const data = {};
        data.userData = localStorage.getItem('userData');
        data.country = localStorage.getItem('country');
        const win = window.open(`${"http://localhost:8081/b2b_cms/shipmentReport?status="+hrefValue}&isFromLocalhost=true`, '_blank');
        window.addEventListener('message', function handshakeListener(event) {
            if (event.origin !== 'http://localhost:8081') return;
            if (event.data === 'ready') {
            win.postMessage(data, 'http://localhost:8081');
            window.removeEventListener('message', handshakeListener);
            }
        });
        } else {
        window.open(`${this.b2b_cms_url+hrefValue}`,'_blank');
        }
    },
    getb2bDashboardCountForAdmin(){
      this.failMsgForB2BDashboard = null
      document.getElementById('overlay').style.display="none";
      var userdata = localStorage.getItem("userData");
      var userInfo = userdata ? JSON.parse(userdata) : null;
      const b2b_api_url = window.location.origin=='http://localhost:8080' ? `http://localhost:8086/b2b/getDashBoardAwbCount` : `${CONSTANTS.API_URL}/b2b/getDashBoardAwbCount`
      this.$http.post(b2b_api_url)
      .then((result)=>{
        this.showB2BDashboardLoader = false
        if (result.data.returnmsg === "Successful") {
          const forward = result.data.returnvalue.ParentAWB;
          const reverse = result.data.returnvalue.reverseParentAWB;

          // Map to bucket arrays for new design
          this.b2bForwardBuckets = [
            { label: "BookingPending", value: forward.BookingPending || 0, icon: "fas fa-calendar-plus", color: "#3498db" },
            { label: "OFD", value: forward.OFD || 0, icon: "fas fa-truck", color: "#2ecc71" },
            { label: "Delivered", value: forward.Delivered || 0, icon: "fas fa-check-circle", color: "#e74c3c" },
            { label: "NDR", value: forward.NDR || 0, icon: "fas fa-exclamation-circle", color: "#f39c12" },
            { label: "RTO", value: forward.RTO || 0, icon: "fas fa-undo-alt", color: "#e67e22" }
          ];
          this.b2bReverseBuckets = [
            { label: "PickupPending", value: reverse.PickupPending || 0, icon: "fas fa-clock", color: "#3498db" },
            { label: "PickupDone", value: reverse.PickupDone || 0, icon: "fas fa-check", color: "#2ecc71" },
            { label: "DeliveredToWH", value: reverse.DeliveredToWH || 0, icon: "fas fa-warehouse", color: "#e74c3c" },
            { label: "NPR", value: reverse.NPR || 0, icon: "fas fa-exclamation-circle", color: "#f39c12" }
          ];
        }
        else {
          this.failMsgForB2BDashboard = "No Data Found!"
          console.log('failMsgForB2BDashboard',this.failMsgForB2BDashboard)

          this.b2bForwardBuckets = [
            { label: "Booking Pending", value: 0, icon: "fas fa-calendar-plus", color: "#3498db" },
            { label: "OFD", value: 0, icon: "fas fa-truck", color: "#2ecc71" },
            { label: "Delivered", value: 0, icon: "fas fa-check-circle", color: "#e74c3c" },
            { label: "NDR", value: 0, icon: "fas fa-exclamation-circle", color: "#f39c12" },
            { label: "RTO", value: 0, icon: "fas fa-undo-alt", color: "#e67e22" }
          ];
          this.b2bReverseBuckets = [
            { label: "Pickup Pending", value: 0, icon: "fas fa-clock", color: "#3498db" },
            { label: "Pickup Done", value: 0, icon: "fas fa-check", color: "#2ecc71" },
            { label: "Delivered To WH", value: 0, icon: "fas fa-warehouse", color: "#e74c3c" },
            { label: "NPR", value: 0, icon: "fas fa-exclamation-circle", color: "#f39c12" }
          ];
        }
      })
      .catch((error)=>{
        this.showB2BDashboardLoader = false
        this.failMsgForB2BDashboard = "Error in getting data!"
        console.log('failMsgForB2BDashboard',this.failMsgForB2BDashboard)
        this.$fire({
          text: "",
          type: "warning",
          timer: 30000
        }); 
      })

    },
    getVendorPickupDetails() {
      // API call to getdashboardshipmentcountforfirstmile
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // this.loader.vendor = true;

      const obj = {
        hub_id: `${userInfo.pickuplocationmasterid}`,
        vendor_id: this.selectedVendor || null
      };

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVendorPickupDetails_ksa`, obj)
        .then(result => {
          // this.loader.vendor = false;
          const p2p = result.body.returnvalue
          this.vendorStatsDoc = [
            {
              label: "Ready to Allocate the Rider",
              value: p2p.Vendor_Pickup_Not_Assigned || 0,
              icon: "fas fa-user-clock",
              color: "#3498db"
            },
            {
              label: "Rider Pickup Pending",
              value: p2p.Vendor_Pickup_Assigned || 0,
              icon: "fas fa-user-check",
              color: "#2ecc71"
            },
            {
              label: "Rider Pickup Done",
              value: p2p.Vendor_Pickup_INTransit || 0,
              icon: "fas fa-motorcycle",
              color: "#e74c3c"
            },
            {
              label: "Received in Hub",
              value: p2p.Vendor_Handoverdone_to_P2P_Hub || 0,
              icon: "fas fa-warehouse",
              color: "#f39c12"
            }
          ];
        })
        .catch(() => {
          // this.loader.vendor = false;
        });
    },
    getLpcDispatchDetails() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // this.loader.lpc = true;
      const obj = {
        hub_id: userInfo.pickuplocationmasterid,
        shipmenttype: this.selectedLpcType || "all",
        vendor_id: this.selectedLpcType === "vendor" ? this.selectedLpcVendor || null : null
      };
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getLpcDispatchDetails_ksa`, obj)
        .then(result => {
          if (result.data.returnmsg === "Successful") {
            // this.loader.lpc = false;
            const data = result.data.returnvalue;
            this.lpcStatsDoc = [
              { label: "Shipment Created", value: data.shipment_created || 0, icon: "fas fa-box", color: "#3498db" },
              { label: "Shipment Received", value: data.shipment_received || 0, icon: "fas fa-check-circle", color: "#2ecc71" },
              { label: "HUB Inscan", value: data.hub_inscan || 0, icon: "fas fa-warehouse", color: "#e74c3c" },
              { label: "Pallet Created", value: data.pallet_created || 0, icon: "fas fa-pallet", color: "#f39c12" },
              { label: "Pallet Closed", value: data.pallet_closed || 0, icon: "fas fa-times-circle", color: "#e67e22" },
              { label: "Dispatch from LPC", value: data.dispatch_from_lpc || 0, icon: "fas fa-truck", color: "#2980b9" },
            ];
          }else{
            this.lpcStatsDoc = [
              { label: "Shipment Created", value: 0, icon: "fas fa-box", color: "#3498db" },
              { label: "Shipment Received", value: 0, icon: "fas fa-check-circle", color: "#2ecc71" },
              { label: "HUB Inscan", value: 0, icon: "fas fa-warehouse", color: "#e74c3c" },
              { label: "Pallet Created", value: 0, icon: "fas fa-pallet", color: "#f39c12" },
              { label: "Pallet Closed", value: 0, icon: "fas fa-times-circle", color: "#e67e22" },
              { label: "Dispatch from LPC", value: 0, icon: "fas fa-truck", color: "#2980b9" },
            ];
          }
        })
        .catch(() => {
          // this.loader.lpc = false;
        });
    },

    getRTODetails() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // this.loader.rto = true;
        const obj = {
            hub_id: userInfo.pickuplocationmasterid,
            vendor_id: this.selectedRtoVendor || null
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getRTODetails_ksa`, obj)
        .then(result => {
            // this.loader.rto = false;
            if (result.data.returnmsg === "Successful") {
                const data = result.data.returnvalue;
                this.rtoStatsDoc = [
                    { label: "RTO Received in LPC", value: data.RTO_Dispatch || 0, icon: "fas fa-truck-loading", color: "#3498db" },
                    { label: "Rintransit LMD TO LPC", value: data.RTO_Received || 0, icon: "fas fa-check-circle", color: "#2ecc71" },
                    { label: "RBookingDone", value: data.RTO_BookingDone, icon: "fas fa-tasks", color: "#f39c12" },
                    { label: "RTO Handover to WH", value: data.RTO_Handover || 0, icon: "fas fa-warehouse", color: "#f39c12" }
                ];
            } else {
                this.rtoStatsDoc = [
                    { label: "RTO Received in LPC", value: data.RTO_Dispatch || 0, icon: "fas fa-truck-loading", color: "#3498db" },
                    { label: "Rintransit LMD TO LPC", value: data.RTO_Received || 0, icon: "fas fa-check-circle", color: "#2ecc71" },
                    { label: "RBookingDone", value: 0, icon: "fas fa-tasks", color: "#f39c12" },
                    { label: "RTO Handover to WH", value: 0, icon: "fas fa-warehouse", color: "#f39c12" }
                ];
            }
        })
        .catch(() => {
            // this.loader.rto = false;
        });
    },

    getHubWisePendingDetails() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // this.loader.dispatch = true;

      const obj = {
        hub_id: userInfo.pickuplocationmasterid
      };

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDispatchPendingDetails_ksa`, obj)
      .then(result => {
        // this.loader.dispatch = false;
        if (result.data.returnmsg === "Successful") {
          const colorMap = {
            "Makkah": "mak",
            "Jeddah": "jed",
            "Riyadh": "riyad",
            "Dammam": "dammam"
          };
          const icon = "fas fa-warehouse";
          this.hubPending = result.data.returnvalue.map(hub => ({
            name: hub.pickuplocationname + " Hub",
            pending: Number(hub.pending_dispatch_count),
            lastDispatch: hub.last_dispatch_date,
            todaysDispatch: Number(hub.todays_dispatch_count),
            color: colorMap[hub.pickuplocationname] || "",
            icon,
            pickuplocationmasterid: hub.pickuplocationmasterid
          }));
        } else {
          this.hubPending = [];
        }
      })
      .catch(() => {
        // this.loader.dispatch = false;
        this.hubPending = [];
      });
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 20px;
  border-bottom: 2px solid #f0f0f0;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 2rem;
}
.hub-pending-card {
  border-radius: 10px;
  min-height: 150px;
}
.hub-pending-card.mak { border-top: 5px solid #e74c3c; }
.hub-pending-card.jed { border-top: 5px solid #2ecc71; }
.hub-pending-card.riyad { border-top: 5px solid #f39c12; }
.hub-pending-card.dammam { border-top: 5px solid #008b8b; }
.stat-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  text-align: center;
  min-height: 140px;
  max-height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
}
.stat-icon {
  font-size: 24px;
  margin-bottom: 6px;
  line-height: 1;
}
.stat-value {
  font-size: 32px;
  font-weight: bold;
  margin: 0;
  color: #2c3e50;
  line-height: 1.1;
}
.stat-label {
  color: #7f8c8d;
  font-size: 14px;
  margin: 2px 0 0 0;
  line-height: 1.1;
}
</style>